var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start",attrs:{"fluid":"","pa-0":"","fill-height":""}},[_c('FullHeader',{attrs:{"headerType":2}}),_c('ClosedProjectListIndex',{attrs:{"listingType":_vm.$store.projectsStore.state.listingType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }